import UserLocalStorage from '@sh/lib/UserLocalStorage.class';

export default new UserLocalStorage();
